import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Trash2 } from "lucide-react";

function ItemRow({ item, index, onChange, onRemove, canRemove }) {
  var lineTotal = (item.quantity * item.unit_price).toFixed(2);
  return React.createElement("div", { className: "flex gap-2 items-start", key: index },
    React.createElement(Input, {
      placeholder: "Description", value: item.description,
      onChange: function(e) { onChange(index, "description", e.target.value); },
      className: "flex-1", "data-testid": "item-desc-" + index
    }),
    React.createElement(Input, {
      type: "number", placeholder: "Qté", value: item.quantity,
      onChange: function(e) { onChange(index, "quantity", e.target.value); },
      className: "w-20", "data-testid": "item-qty-" + index
    }),
    React.createElement(Input, {
      type: "number", placeholder: "Prix", value: item.unit_price,
      onChange: function(e) { onChange(index, "unit_price", e.target.value); },
      className: "w-28", "data-testid": "item-price-" + index
    }),
    React.createElement("span", { className: "text-sm font-medium w-24 text-right pt-2" }, lineTotal + " EUR"),
    canRemove ? React.createElement(Button, {
      type: "button", variant: "ghost", size: "icon", className: "h-9 w-9",
      onClick: function() { onRemove(index); }
    }, React.createElement(Trash2, { className: "w-3 h-3" })) : null
  );
}

import React from "react";

export function InvoiceItemsList({ items, onItemChange, onAddItem, onRemoveItem }) {
  var subtotal = items.reduce(function(sum, item) { return sum + (item.quantity * item.unit_price); }, 0);
  
  var rows = [];
  for (var i = 0; i < items.length; i++) {
    rows.push(React.createElement(ItemRow, {
      key: i, item: items[i], index: i,
      onChange: onItemChange, onRemove: onRemoveItem,
      canRemove: items.length > 1
    }));
  }

  return React.createElement("div", null,
    React.createElement("div", { className: "flex items-center justify-between mb-2" },
      React.createElement(Label, null, "Prestations"),
      React.createElement(Button, {
        type: "button", variant: "outline", size: "sm", onClick: onAddItem, "data-testid": "add-item-btn"
      }, React.createElement(Plus, { className: "w-3 h-3 mr-1" }), " Ligne")
    ),
    React.createElement("div", { className: "space-y-2" }, rows),
    React.createElement("div", { className: "mt-3 text-right" },
      React.createElement("p", { className: "text-base font-semibold" }, "Sous-total: " + subtotal.toFixed(2) + " EUR")
    )
  );
}
